<template>
  <v-app-bar
      elevation="0"
      class="main-header"
      height="64"
      fixed
      color='white'
      dark
  >
    <v-btn icon class="d-flex d-sm-none" color="primary" @click.stop="TOGGLE_DRAWER">
      <template v-if="DRAWER_STATE">
        <v-icon size="28" :class="$vuetify.theme.dark ? 'primary--text' : null">arrow_back</v-icon>
      </template>
      <template v-else>
        <v-icon size="28" :class="$vuetify.theme.dark ? 'primary--text' : null">menu</v-icon>
      </template>
    </v-btn>
    <v-toolbar-title>
      <router-link :to="gotoHome">
        <v-img v-if="customer.logoUrl === null" height="25" contain src="@/assets/logo-viewelevator-blue.png"></v-img>
        <v-img v-else height="25" contain :src="getPath()"></v-img>
      </router-link>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <div class="header-links d-none d-sm-flex ml-10">
        <v-btn
            v-for="(item, i) in checkRolesAndMain(navLinks)"
            :key="i"
            text
            active-class="navbar-link--active"
            :to="item.route"
            class="text-capitalize primary--text"
        >
          {{ $t('display/navbar:links.' + item.text) }}
        </v-btn>

      <v-menu
          min-width="180"
          offset-y
          bottom
          nudge-bottom="14"
          v-if="checkStatisticRole"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              text
              v-bind="attrs"
              v-on="on"
              class="text-capitalize primary--text"
          >
            {{ $t('display/navbar:links.statistics') }}
            <v-icon class="ml-1">expand_more</v-icon>
          </v-btn>
        </template>
        <v-list
            v-if="checkStatisticRole"
        >
          <v-list-item-group color="primary">
            <v-list-item
                v-for="(item, i) in statisticLinks"
                :key="i"
                :to="item.route"
                link
                @click="item.action ? item.action() : null"
            >
              <v-list-item-action class="mr-2" v-if="item.icon">
                <v-icon class="greyTint--text">{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t('display/navbar:statistic.' + item.text) }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>

      <v-menu
        v-if="isAdmin"
        min-width="180"
        offset-y
        bottom
        nudge-bottom="14"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            v-bind="attrs"
            v-on="on"
            class="text-capitalize primary--text"
          >
            {{ $t('display/navbar:links.logs') }}
            <v-icon class="ml-1">expand_more</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item-group color="primary">
            <v-list-item
              v-for="(item, i) in logsLinks"
              :key="i"
              :to="item.route"
              link
              @click="item.action ? item.action() : null"
            >
              <v-list-item-action class="mr-2" v-if="item.icon">
                <v-icon class="greyTint--text">{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t('display/navbar:logs.' + item.text) }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>
    </div>

    <!-- TODO uncomment search component if needed in future -->
    <!-- <v-spacer></v-spacer>
    <Search/> -->

    <UserMenu
      :user="user"
    />

    <!-- LanguageSelector -->
    <LanguageMenu />

  </v-app-bar>
</template>

<script>
import {Role} from '@/modules/core/data/roles';
import store from '@/store';
import {mapActions, mapState} from 'vuex'
import config from '@/config';
import UsersService from '@/modules/core/services/users-service';
import DataUtils from '@/modules/core/services/data-utils';
import UserMenu from '@/modules/core/components/Header/UserMenu';
import LanguageMenu from '@/modules/core/components/Header/LanguageMenu';
import Users from '@/modules/core/data/users';
import ModuleSwitcher from '@/plugins/module-switcher';
import CustomerService from "@/modules/core/services/customer-service";
import Customer from "@/modules/core/data/customer";

// TODO uncomment search component if needed in future
// import Search from '@/modules/core/components/Search/Search'
const URL_PREFIX = '/' + store.state.manager.displayModuleUrl;

export default {
  name: 'DisplayHeader',
  components: {
    // TODO uncomment search component if needed in future
    // Search
    UserMenu,
    LanguageMenu
  },
  data: () => ({
    config,
    searchCollapse: true,
    ownsDisplay: true, //may access the media instance
    messageBadge: true,
    user: [],
    customer: {},
    navLinks: [
      {text: 'advert', route: URL_PREFIX + '/advert', main: false, roles: [Role.Admin, Role.FacilityManager, Role.ViewEmployee]},
      {text: 'elevator', route: URL_PREFIX + '/elevator', main: false, roles: [Role.Admin, Role.FacilityManager, Role.ViewEmployee]},
      {text: 'offer', route: URL_PREFIX + '/offer', main: false, roles: [Role.Admin, Role.Master]},
      {text: 'certificates', route: URL_PREFIX + '/certificate', main: false, roles: [Role.Admin]},
      {text: 'editor', route: URL_PREFIX + '/editor', main: false, roles: [Role.Admin, Role.ViewEmployee, Role.FacilityManager]},
      {text: 'pdfs', route: URL_PREFIX + '/pdfs', main: false, roles: [Role.Admin, Role.Master]},
      {text: 'emergencies', route: URL_PREFIX + '/emergency', main: false, roles: [Role.Admin, Role.FacilityManager, Role.ViewEmployee]}
    ],
    logsLinks: [
      { text: 'advert', route: URL_PREFIX + '/logs/advert', main: false },
      { text: 'alive', route: URL_PREFIX + '/logs/alive', main: false },
      { text: 'bootLog', route: URL_PREFIX + '/logs/bootlog', main: false },
      { text: 'download', route: URL_PREFIX + '/logs/download', main: false },
      { text: 'elevator-day', route: URL_PREFIX + '/logs/elevator-day', main: false },
      { text: 'elevator-week', route: URL_PREFIX + '/logs/elevator-week', main: false },
      { text: 'elevator-month', route: URL_PREFIX + '/logs/elevator-month', main: false },
      { text: 'emails', route: URL_PREFIX + '/logs/email', main: false },
      { text: 'log-file', route: URL_PREFIX + '/logs/logfile', main: false },
      { text: 'offline', route: URL_PREFIX + '/logs/offline', main: false },
      { text: 'ride', route: URL_PREFIX + '/logs/ride', main: false },
      { text: 'schedule', route: URL_PREFIX + '/logs/schedule', main: false },
      { text: 'update', route: URL_PREFIX + '/logs/update', main: false }
    ],
    statisticLinks: [
      { text: 'elevator', route: URL_PREFIX + '/statistic/elevator', main: false },
      { text: 'advert', route: URL_PREFIX + '/statistic/advert', main: false },
      { text: 'workload', route: URL_PREFIX + '/statistic/workload', main: false },
      { text: 'budget', route: URL_PREFIX + '/statistic/budget', main: false }
    ]
  }),
  computed: {
    // Template
    ...mapState('display/layout',
      {drawer: state => state.drawer}
    ),
    DRAWER_STATE: {
      get() {
        return this.drawer
      },
    },
    isAdmin() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes(Role.Admin);
      }
      return false;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    checkStatisticRole() {
      return this.hasRole([Role.Admin, Role.ViewEmployee])
    },
    gotoHome() {
      return !this.hasRole([Role.Admin]) && ModuleSwitcher.isOnlyDisplay()
          ? ModuleSwitcher.getDisplayHomeUrl() : '/home';
    }
  },
  methods: {
    // Template
    ...mapActions('display/layout', ['TOGGLE_DRAWER']),

    getPath() {
      if (this.customer === undefined || this.customer.logoUrl === undefined)
        return;

      return process.env.VUE_APP_ROOT_HOST + this.customer.logoUrl + "?" + Math.random();
    },
    checkRolesAndMain: function (links) {
      var self = this;
      return links.filter(function (link) {
        return (!link.main || (link.main && self.isMain))
          && self.hasRole(link.roles);
      })
    },
    hasRole(roles) {
      if (this.currentUser && this.currentUser.roles) {
        for (let i = 0; i < roles.length; i++) {
          if (this.currentUser.roles.includes(roles[i])) {
            return true;
          }
        }
      }
      return false;
    }
  },
  created() {
    UsersService.readProfileFromAPI(
      (resp) => {
        var response = DataUtils.parseDataToSingleObject(resp.data, Users);
        if (response == null) {
          this.$logger.error("Failed to receive user data!");
        } else {
          this.user = response;
          CustomerService.readProfileFromAPI(
              (resp) => {
                var response = DataUtils.parseDataToSingleObject(resp.data, Customer);
                this.customer = response;
              })
        }
      }
    )
  }
};
</script>

<style src="@/modules/core/components/Header/Header.scss" lang="scss"></style>
